import { render, staticRenderFns } from "./CandidatesPage.vue?vue&type=template&id=7f0953a7"
import script from "./CandidatesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidatesPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports